var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.1 338.3",
    style: {
      enableBackground: "new 0 0 330.1 338.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209,267.7h-79.8c-8,0-14.5-6.5-14.5-14.5l-3-103.7c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.8,1.8-0.8H224 c0.7,0,1.3,0.3,1.8,0.8c0.5,0.5,0.7,1.1,0.7,1.8l-3,103.8C223.5,261.2,217,267.7,209,267.7z M116.8,151.9l2.9,101.2 c0,5.3,4.3,9.6,9.5,9.6H209c5.2,0,9.5-4.3,9.5-9.5l2.9-101.3H116.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.1,151.9h-136c-1.4,0-2.5-1.1-2.5-2.5v-14c0-8,6.5-14.5,14.5-14.5h112c8,0,14.5,6.5,14.5,14.5v14 C239.6,150.8,238.5,151.9,237.1,151.9z M103.6,146.9h131v-11.5c0-5.2-4.3-9.5-9.5-9.5h-112c-5.2,0-9.5,4.3-9.5,9.5V146.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.8,252.3c-1.4,0-2.5-1.1-2.5-2.4l-2-86.3c0-1.4,1.1-2.5,2.4-2.6c1.4-0.1,2.5,1.1,2.6,2.4l2,86.3 C142.3,251.2,141.2,252.3,139.8,252.3C139.8,252.3,139.8,252.3,139.8,252.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168.3,252.3c-1.4,0-2.5-1.1-2.5-2.5v-86.3c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5v86.3 C170.8,251.2,169.7,252.3,168.3,252.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.9,252.3C196.9,252.3,196.8,252.3,196.9,252.3c-1.4,0-2.5-1.2-2.5-2.6l2-86.3c0-1.4,1.1-2.4,2.5-2.4 c0,0,0,0,0.1,0c1.4,0,2.5,1.2,2.4,2.6l-2,86.3C199.3,251.3,198.2,252.3,196.9,252.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.5,125.9c-1.4,0-2.5-1.1-2.5-2.5v-6.9c0-5.2-4.3-9.5-9.5-9.5h-36c-5.2,0-9.5,4.3-9.5,9.5v6.9 c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5v-6.9c0-8,6.5-14.5,14.5-14.5h36c8,0,14.5,6.5,14.5,14.5v6.9 C204,124.8,202.9,125.9,201.5,125.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.e75270a534bae6a18fd3e70587dd4444.svg";
export { ForwardRef as ReactComponent };